import { css } from "@compiled/react";

import Epic16Icon from "@atlaskit/icon-object/glyph/epic/16";

type Epic16IconCustomProps = {
    readonly primaryColor: string;
    readonly label: string;
};

export const Epic16IconCustom = ({
    primaryColor,
    label
}: Epic16IconCustomProps) => {
    const colorOverride = css({
        path: {
            fill: primaryColor
        }
    });

    return (
        <div css={colorOverride}>
            <Epic16Icon label={label} />
        </div>
    );
};
